import {defineStore} from 'pinia'
import type {OutputZone, OutputZoneChannelData} from "~/models"

export const useChannelsStore = defineStore('channels', {
    state: () => ({
        zones: [] as OutputZone[],
    }),
    actions: {
        async load() {
            this.zones = await useApi().getFlyZones()
        },

        /**
         * Оновлює лічильники активності зони з даних, що прийшли по SSE.
         * Потрібно щоб фільтр "активні зони" не чекав перезавантаження списку зон.
         */
        applyZoneActivity(zoneId: number, data: OutputZoneChannelData) {
            const zone = this.zones.find(item => item.id === zoneId)
            if (!zone) return

            zone.activeMissions = data.flightStatus?.length || 0
            zone.queuedMissions = data.queue?.length || 0
        },
    },
})
